/* tslint:disable */
/* eslint-disable */
/**
 * Oasis Nexus API V1
 * An API for accessing indexed data from the Oasis Network.  <!-- Acts as a separator after search in sidebar --> # Endpoints 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    RoothashMessage,
    RoothashMessageFromJSON,
    RoothashMessageFromJSONTyped,
    RoothashMessageToJSON,
} from './';

/**
 * 
 * @export
 * @interface RoothashMessageListAllOf
 */
export interface RoothashMessageListAllOf {
    /**
     * 
     * @type {Array<RoothashMessage>}
     * @memberof RoothashMessageListAllOf
     */
    roothash_messages: Array<RoothashMessage>;
}

export function RoothashMessageListAllOfFromJSON(json: any): RoothashMessageListAllOf {
    return RoothashMessageListAllOfFromJSONTyped(json, false);
}

export function RoothashMessageListAllOfFromJSONTyped(json: any, ignoreDiscriminator: boolean): RoothashMessageListAllOf {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'roothash_messages': ((json['roothash_messages'] as Array<any>).map(RoothashMessageFromJSON)),
    };
}

export function RoothashMessageListAllOfToJSON(value?: RoothashMessageListAllOf | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'roothash_messages': ((value.roothash_messages as Array<any>).map(RoothashMessageToJSON)),
    };
}


